import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { historyShape } from 'constants/propTypes';
import ApolloErrorSection from 'components/errors/ApolloErrorSection';
import GenericErrorSection from 'components/errors/GenericErrorSection';
import AgentPortalError from '../../../errors/AgentPortalError';

class ErrorBoundary extends Component {
  state = {
    error: null
  };

  componentDidMount() {
    const { history } = this.props;
    this.historyUnlisten = history.listen(() => {
      this.setState({ error: null });
    });
  }

  componentWillUnmount() {
    this.historyUnlisten();
  }

  componentDidCatch(error) {
    this.setState({ error });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error instanceof AgentPortalError) {
      return <ApolloErrorSection error={error} parent={this} />;
    }

    if (error) {
      return <GenericErrorSection error={error} parent={this} />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  history: historyShape
};

export default injectIntl(ErrorBoundary);
